module.exports = __webpack_public_path__ + "img/star sapphire_sc1.b4d9563a.png";